import { render, staticRenderFns } from "./staffHistoryDetail.vue?vue&type=template&id=4c7c471c"
import script from "./staffHistoryDetail.vue?vue&type=script&lang=js"
export * from "./staffHistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./staffHistoryDetail.vue?vue&type=style&index=0&id=4c7c471c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports